import { getAxiosClient } from "../../axios-client";
import { EditPackageRequestBody, EditPackageResponse } from "./types";

const axiosClient = getAxiosClient();
export const editPackage = async (body: EditPackageRequestBody) => {
  return await axiosClient.ax.put<EditPackageResponse>(
    "/Packages/Update",
    body
  );
};
